import React, { FC } from 'react';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';

import { CustomDropDownPropsType } from './types';

const CustomDropDown: FC<CustomDropDownPropsType> = ({
  placeHolder,
  dropDownValue,
  onSelectItem,
  properties,
  dataTestId
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel
        id="demo-simple-select-label"
        sx={{
          '&.Mui-focused .MuiInputLabel-root': {
            borderColor: '#00000060',
            color: '#00000060'
          }
        }}>
        {placeHolder}
      </InputLabel>
      <Select
        fullWidth
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={dropDownValue}
        label={placeHolder}
        sx={{
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00000060',
            color: '#00000060'
          },
          '&.Mui-focused .MuiOutlinedInput-root': {
            color: '#00000060'
          }
        }}
        onChange={onSelectItem}
        {...(dataTestId
          ? {
              SelectDisplayProps: {
                'data-testid': dataTestId
              } as React.HTMLAttributes<HTMLDivElement>
            }
          : {})}>
        {properties.map((item, index) => (
          <MenuItem
            key={index}
            data-testid={
              dataTestId ? `${dataTestId}-option-${item.value}` : undefined
            }
            value={item.value}
            disabled={item.disabled || false}>
            {item.displayName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomDropDown;
